import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Mangystau.png'
import _imports_1 from '@/assets/images/mang1.jpg'
import _imports_2 from '@/assets/images/mang2.jpg'
import _imports_3 from '@/assets/images/mang3.jpg'
import _imports_4 from '@/assets/images/mang4.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Мангистауская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Мангистауская область – здесь соседствуют пустынные и морские пейзажи. Городские экскурсии, морские прогулки, фотосессии в безлюдных пустынях плато Устюрт– каждый путешественник найдет здесь что-то интересное для себя. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, " Интересные Туристические Объекты Региона ")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Казахстацы, предпочитающие исторический внутренний туризм (статистика говорит о постоянном росте заинтересованности этой сферой) найдут в Мангистауской области немало интересных объектов. Популярностью пользуются туры к подземным мечетям и некрополям, а также к наскальным рисункам-поэмам. "),
        /*#__PURE__*/_createVNode("p", null, " Иностранцы, как свидетельствует статистика туризма Мангистауской области, предпочитают поездки в города региона. Гостям из России и Европы нравятся прогулки по современной набережной портового Актау с видом на маяк, расположенный на крыше жилого дома. В 2018 году в окрестностях города была открыта прогулочная скальная тропа вдоль берега Каспийского моря длиной в несколько километров, с оригинальной разноцветной подсветкой, перилами и многочисленными скамейками для отдыха. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Будет интересна поездка в эти места и туристам из Украины – в местной крепости "),
          /*#__PURE__*/_createVNode("b", null, "Форт-Александровский"),
          /*#__PURE__*/_createTextVNode(" когда-то отбывал ссылку известный украинский поэт Тарас Шевченко. Сегодня этот город носит имя этого знаменитого узника – Форт-Шевченко, в честь него в городских музеях открыты постоянные экспозиции. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "5630")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "21,0")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "157512")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "18218")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Экотуризм")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Природные туры в Мангистауской области предполагают различные путешествия по плато "),
          /*#__PURE__*/_createVNode("b", null, "Устюрт"),
          /*#__PURE__*/_createTextVNode(", где, действительно, есть на что посмотреть! Можно полюбоваться останцами в урочище "),
          /*#__PURE__*/_createVNode("b", null, "Бозжыра"),
          /*#__PURE__*/_createTextVNode(", горами "),
          /*#__PURE__*/_createVNode("b", null, "Шеркала"),
          /*#__PURE__*/_createTextVNode(" и "),
          /*#__PURE__*/_createVNode("b", null, "Бокты"),
          /*#__PURE__*/_createTextVNode(", побывать в долине шаров "),
          /*#__PURE__*/_createVNode("b", null, "Торыш"),
          /*#__PURE__*/_createTextVNode(", в гигантской котловине "),
          /*#__PURE__*/_createVNode("b", null, "Жыгылган"),
          /*#__PURE__*/_createTextVNode(", посетить "),
          /*#__PURE__*/_createVNode("b", null, "Устюртский заповедник"),
          /*#__PURE__*/_createTextVNode(", всего и не перечислишь! Пляжный отдых в этих местах можно организовать на известном далеко за пределами региона песчаном пляже "),
          /*#__PURE__*/_createVNode("b", null, "«Голубая бухта»"),
          /*#__PURE__*/_createTextVNode(" близ города Актау. Как развивается туризм в Мангистауской области? Организуются новые и оборудуются давно действующие места размещения, совершенствуется придорожная инфраструктура, запускаются оригинальные туристические маршруты. К примеру, интересным направлением обещают стать морские прогулки на "),
          /*#__PURE__*/_createVNode("b", null, "Тюленьи острова"),
          /*#__PURE__*/_createTextVNode(" – живописный архипелаг около северных берегов Каспия. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как развивается туризм в Кызылординской области? Этот сегмент рынка в регионе достаточно перспективен. Уже сейчас под охрану государства в области взяты более полутысячи историко-культурных объектов. В рамках программы «Рухани жаңғыру» ведутся археологические изыскания, реставрационные работы. Как часть проекта «Цифровой Казахстан», была создана интерактивная карта туристических объектов, и на 150 из них установлены QR-коды с основной информацией о памятнике. ")
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}